export default __webpack_public_path__ + "static/media/ranking-example.309d01af.gif";